module.exports = __webpack_public_path__ + "static/media/patron-4.57071f9d.svg";